<!-- Card displaying balance information -->
<div class="card mb-2">
  <!-- Balance header with localized text -->
  <div class="text-lg p-4 flex flex-row justify-between">
    <span>{{ 'Balance' | transloco }}</span>
    <div>
      <!-- Displaying balance of users and total licenses -->
      <span class="text-xl"></span>
      <span class="text-secondary">
        {{ userManagementService?.usersSummary?.balance_of_users }} /
        {{ userManagementService.totalLicenses }}
      </span>
    </div>
  </div>
  <!-- Placeholder for additional balance information -->
  <div class="px-4"></div>
</div>

<!-- Card displaying user summary -->
<div class="card">
  <!-- User summary header with localized text -->
  <div class="text-lg p-4">{{ 'User Summary' | transloco }}</div>
  <!-- List of user summary items -->
  <ul class="mb-2 px-5">
    <!-- Loop through each item in userSummaryItems array -->
    <li *ngFor="let item of userSummaryItems" class="flex flex-col w-full">
      <div class="flex flex-row w-full justify-between">
        <!-- Displaying item label with localized text -->
        <label class="text-primary">{{ item.label | transloco }}</label>
        <!-- Displaying the user summary value -->
        <div class="text-xl">
          {{ userManagementService?.usersSummary[item.key] }}
          <small>{{ 'Users' | transloco }}</small>
        </div>
      </div>
      <!-- Divider for specific items -->
      <mat-divider
        class="my-2"
        *ngIf="item.key === 'total_users' || item.key === 'inactive_users'"
      ></mat-divider>
    </li>
  </ul>
</div>
